import { apiClient } from "services/api-client"

const buildFilterQueryString = (typeFilter, searchContent, startDate, endDate, service, actorType, targetCompanyKey) => {
    let dateFilter = '';
    if (startDate && endDate) {
      dateFilter = `&startDate=${startDate}&endDate=${endDate}`
    } else if (startDate && !endDate) {
      dateFilter = `&startDate=${startDate}`
    } else if (!startDate && endDate) {
      dateFilter = `&endDate=${endDate}`
    }
    let searchFilter = '';
    if (searchContent) {
      searchFilter = `&typeFilter=${typeFilter}&searchContent=${searchContent}`;
    }
    let serviceFilter = '';
    if (service) {
      serviceFilter = `&service=${service}`;
    }
    let actorTypeFilter = '';
    if (actorType) {
      actorTypeFilter = `&actorType=${actorType}`;
    }
    let targetCompanyFilter = '';
    if (targetCompanyKey) {
      targetCompanyFilter = `&targetCompanyKey=${targetCompanyKey}`;
    }
    return `${searchFilter}${dateFilter}${serviceFilter}${actorTypeFilter}${targetCompanyFilter}`;
}

export const getAuditLogPaged = async (
    tenant,
    page,
    perPage,
    typeFilter,
    searchContent,
    startDate,
    endDate,
    service,
    actorType,
    targetCompanyKey,
    displayTimezone
) => {
    const filters = buildFilterQueryString(typeFilter, searchContent, startDate, endDate, service, actorType, targetCompanyKey);
    const timezoneFilter = displayTimezone ? `&displayTimezone=${encodeURIComponent(displayTimezone)}` : '';
    return await apiClient.get(`/user/audit-log?companyKey=${tenant}&page=${page}&perPage=${perPage}${filters}${timezoneFilter}`)
}

// SPEC-AUDIT-003 FR-9: same filter dimensions as getAuditLogPaged, unpaginated — hits the
// new /export endpoint, which enforces its own real row cap server-side.
export const getAuditLogExport = async (
    tenant,
    typeFilter,
    searchContent,
    startDate,
    endDate,
    service,
    actorType,
    targetCompanyKey,
    displayTimezone
) => {
    const filters = buildFilterQueryString(typeFilter, searchContent, startDate, endDate, service, actorType, targetCompanyKey);
    const timezoneFilter = displayTimezone ? `&displayTimezone=${encodeURIComponent(displayTimezone)}` : '';
    return await apiClient.get(`/user/audit-log/export?companyKey=${tenant}${filters}${timezoneFilter}`)
}